/**
 * blog-showcase.js — instant tag filtering for the blog index.
 *
 * Progressive by design. The pills are real links to Shopify's `/tagged/…`
 * URLs, so they work with JavaScript off and stay crawlable. This script only
 * takes over when the section reports `data-filter-mode="client"`, which the
 * Liquid sets when the whole blog fits on one page — filtering in place is
 * wrong the moment there is a page 2, because the cards for page 2 are not in
 * the DOM to filter.
 *
 * The URL is kept in sync with history.replaceState so a filtered view can be
 * copied, shared and reloaded without silently losing the filter.
 */
(function () {
  'use strict';

  function init(root) {
    var nav = root.querySelector('.blog-filter');
    if (!nav || nav.dataset.filterMode !== 'client') return;

    var grid = root.querySelector('[data-showcase-grid]');
    if (!grid) return;

    var pills = Array.prototype.slice.call(nav.querySelectorAll('.blog-filter__pill'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-showcase-item]'));
    var empty = root.querySelector('[data-showcase-empty]');

    function tagsOf(el) {
      var raw = el.getAttribute('data-tags') || '';
      return raw.split('||').filter(Boolean);
    }

    function apply(tag, pill) {
      var shown = 0;

      items.forEach(function (item) {
        var match = !tag || tagsOf(item).indexOf(tag) !== -1;
        item.hidden = !match;

        if (match) {
          // Restart the entry animation so a filter change reads as motion
          // rather than a jump-cut.
          item.style.setProperty('--filter-order', shown);
          item.classList.remove('is-filtering-in');
          void item.offsetWidth;
          item.classList.add('is-filtering-in');
          shown++;
        }
      });

      if (empty) empty.hidden = shown > 0;

      pills.forEach(function (p) {
        p.classList.toggle('is-active', p === pill);
      });

      try {
        var url = tag ? pill.getAttribute('href') : nav.querySelector('.blog-filter__pill--all').getAttribute('href');
        window.history.replaceState({ tag: tag }, '', url);
      } catch (e) {
        /* replaceState can throw on some embedded contexts — filtering still works */
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        // Let modified clicks (new tab, download, middle click) behave natively.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        apply(pill.getAttribute('data-tag') || '', pill);
      });
    });

    // Landing directly on /blogs/news/tagged/<tag> renders a server-filtered
    // page; nothing to do. Only a client-side state needs restoring.
    var active = pills.filter(function (p) {
      return p.classList.contains('is-active');
    })[0];
    if (active && active.getAttribute('data-tag')) apply(active.getAttribute('data-tag'), active);
  }

  function boot() {
    document.querySelectorAll('[data-blog-showcase]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-blog-showcase]');
    if (root) init(root);
  });
})();
